<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <div class="form-group">
                        <label for="id">{{ etiquetaAbonadoCampo }}</label>
                        <ValidationProvider name="ID" rules="required" v-slot="{ errors }">
                            <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="etiquetaAbonadoCampo" v-model="numeroAbonado"/>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label for="pin">{{ $t('formularios.pin') }}</label>
                        <ValidationProvider name="pin" rules="required" v-slot="{ errors }">
                            <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="PIN" v-model="pin"/>
                        </ValidationProvider>
                    </div>
                    
                    <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_abono.renovar') }}</span></button>
                </ValidationObserver>
            </div>
            <div class="col-12" v-if="error">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-danger" role="alert">
                                    <p>{{ error }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import { TEATRO_HASH_SDPONFERRADINA, TEATRO_HASH_RACING_FERROL } from '@/constants/teatros';
    import { useOldSeasonLabel } from '@/composables/common/useOldSeasonLabel';

    export default {        
        data() {
            return {
                dni: '',
                loading: false,
                error: false,
                id_persona: '',
                n_abonado_antiguo: '',
                pin: ''
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            esFerrol() {
                return this.teatro?.hash === TEATRO_HASH_RACING_FERROL;
            },
            /** Ferrol pide el número de la temporada anterior; el resto, el ID. */
            etiquetaAbonadoCampo() {
                if (this.esFerrol) {
                    return useOldSeasonLabel();
                }

                return this.etiquetaAbonado;
            },
            numeroAbonado: {
                get() {
                    return this.esFerrol ? this.n_abonado_antiguo : this.id_persona;
                },
                set(valor) {
                    if (this.esFerrol) {
                        this.n_abonado_antiguo = valor;
                    } else {
                        this.id_persona = valor;
                    }
                }
            },
            etiquetaAbonado() {
                // SD Ponferradina rotula el identificador con la temporada de la lista
                // de abonados activa (el nombre de la lista ya es "2025/2026").
                if (this.teatro?.hash === TEATRO_HASH_SDPONFERRADINA) {
                    const abonado = this.teatro?.texto_abonado;
                    const temporada = this.$store.getters.getListaAbonados?.nombre;

                    return temporada
                        ? this.$t('formularios.n_abonado_temporada', { abonado, temporada })
                        : this.$t('formularios.n_abonado', { abonado });
                }

                return this.$t('formularios.id');
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.buscarAbonado();
                }
            },
            terminar() {
                this.$emit('terminado', this.datosAbonado());
            },
            /** Ferrol trabaja con `n_abonado_antiguo`; el resto, con `id_persona`. */
            datosAbonado() {
                if (this.esFerrol) {
                    return { n_abonado_antiguo: this.n_abonado_antiguo, pin: this.pin };
                }

                return { id_persona: this.id_persona, pin: this.pin };
            },
            buscarAbonado() {
                this.loading = true;

                const params = {
                    tid: this.configuracion.hash_teatro,
                    dni: this.dni,
                    pin: this.pin,
                    ...this.datosAbonado()
                }

                this.$store.dispatch(this.config.getVuexAlias('lfp.buscar.abono'), params).then(res => {
                    this.loading = false;
                    this.$emit('terminado', res.data);
                    this.$emit('documentacion', {
                        solicitar_documentacion: !!res.data.solicitar_documentacion,
                        texto_documentacion: res.data.texto_documentacion || ''
                    });
                }).catch(error => {
                    this.loading = false;
                    this.error = error.response.data.message;
                    if(error.response.data.message == 'Nº de abonado o dni incorrecto.' && this.configuracion.hash_teatro == 'akr1V2vNbDdxA3CkLniS') {
                        this.error = 'Nº de ID o PIN incorrecto. Por favor escriba a abonados@albacetebalompie.com con su Nombre, apellidos y DNI';
                    }
                    if(error.response.data.message == 'Nº de abonado o dni incorrecto.' && this.configuracion.hash_teatro == 'I0QtpDfZsTkgWKert1Gp') {
                        this.error = 'Nº ID o PIN incorrecto.';
                    }
                });
            },
        },
        components: {
            ContentOrLoading
        }
    }
</script>
